import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './/assets/styles/global.css'
import 'element-plus/dist/index.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

app.use(router) // 注册路由

Object.entries(ElementPlusIconsVue).forEach(([name, component]) => {
	app.component(name, component)
})

app.mount('#app')
